import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { createLicense } from "../redux/actions/settingActions";
import { getLicenseslist } from "../redux/actions/itSalesActions";
import { toast } from "react-toastify";

const LicenseCreateModal = ({ isOpen, onClose, onLicenseCreated }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const generateLicenseKey = () => {
    const digits = "0123456789";
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let characters = [];

    for (let i = 0; i < 30; i++) {
      characters.push(digits.charAt(Math.floor(Math.random() * digits.length)));
    }

    for (let i = 0; i < 20; i++) {
      characters.push(chars.charAt(Math.floor(Math.random() * chars.length)));
    }

    for (let i = characters.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [characters[i], characters[j]] = [characters[j], characters[i]];
    }

    return characters.join("");
  };

  const onSubmit = (data) => {
    setLoading(true);
    const licenseData = {
      name: data.licenseName,
      licenseKey: generateLicenseKey(),
    };
    
    dispatch(createLicense(licenseData));
    
    setTimeout(() => {
      dispatch(getLicenseslist());
      if (onLicenseCreated) {
        onLicenseCreated();
      }
      reset();
      setLoading(false);
      onClose();
    }, 1000);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header className="border-bottom">
        <Modal.Title className="d-flex align-items-center fs-6">
          Create License Key
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group mb-3">
            <label className="mb-1 text-start">
              License Name <span className="text-danger">*</span>
            </label>
            <input
              {...register("licenseName", {
                required: "License name is required",
                validate: (value) =>
                  value.trim() !== "" || "License name is required",
              })}
              className={`form-input ${
                errors.licenseName ? "error" : ""
              }`}
              placeholder="Enter license name..."
              disabled={loading}
            />
            {errors.licenseName && (
              <span className="error-text">
                {errors.licenseName.message}
              </span>
            )}
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="cancel-btn-deleteModal"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button type="submit" className="add-btn" disabled={loading}>
              {loading ? "Processing..." : "Generate"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default LicenseCreateModal;